import React, { useEffect } from "react";

import ParticipantScore from "./ParticipantScore";

const ShowScore = ({
    comp_id,
    parameters,
    participants,
    scores,
    setScores,
}) => {
    // const fetchScores = () => {
    //     Axios.post(
    //         "https://jarvis.moodi.org/competitions/get_compi_scores",
    //         {
    //             competition: comp_id,
    //         },
    //         {
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //         }
    //     )
    //         .then((res) => console.log(res.data))
    //         .catch((err) => console.error(err));
    // };

    useEffect(() => {
        // fetchScores();
        console.log(scores);
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            <table>
                <thead>
                    <tr>
                        <th className="p-4">Slot No</th>
                        {parameters.map((parameter) => {
                            return (
                                <th className="p-4" key={parameter.mcpId}>
                                    {parameter.parameterName} (
                                    {parameter.parameterWeightage})
                                </th>
                            );
                        })}
                        <th className="p-4">Total Score</th>
                    </tr>
                </thead>
                <tbody>
                    {scores.map((score) => {
                        return (
                            <ParticipantScore
                                participants={participants}
                                score={score}
                                parameters={parameters}
                                competition={comp_id}
                            />
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default ShowScore;
